import Image from "next/image";
import Link from "next/link";

const SubNavbar = ({ hideEllipse, subNavBarLinks }) => {
  return (
    <>
      <div className="sticky z-10  px-0 py-2  top-[60px] md:py-2 md:px-12 bg-nivabupa-blue-ethinosPlanRecommendation ">
        <div className="mx-auto max-w-[1280px] w-full flex flex-row items-center justify-between overflow-auto">
          {subNavBarLinks.map((item, index) => (
            <Link prefetch={false}
              key={index}
              href={`/${item.slug}`}
              className={`text-white hover:text-white hover:underline underline-offset-4 hover:font-semibold md:min-w-fit min-w-[33%] text-center`}
            >
              {item.heading}
            </Link>
          ))}
        </div>
      </div>
      {/* {!hideEllipse && (
        <img
          alt=""
          height={200}
          loading="lazy"
          width={200}
          src="/ethinos-home-page/images/ellipses/EllipseBlogs.png"
          className="absolute top-[0px] right-0 hidden md:block"
        />
      )} */}
    </>
  );
};

export default SubNavbar;
